import { render, staticRenderFns } from "./EmailNotificationPreview.vue?vue&type=template&id=37b7882a&"
import script from "./EmailNotificationPreview.vue?vue&type=script&lang=js&"
export * from "./EmailNotificationPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports